<template>
	<transition name="modal">
		<div id="chart-modal" class="modal">
			<div class="modal-dialog">
				<div id="modal-scroll-element" ref="modalScroll" class="modal-content modal-container">
					<charts-modal-content
						:volatilityChart="volatilityChartLarge"
						:volatilityEquityChart="volatilityEquityChartLarge"
						:volatilityFixedIncomeChart="volatilityFixedIncomeChartLarge"
						:volatilityEquityChartData="volatilityEquityChartData"
						:volatilityFixedIncomeChartData="volatilityFixedIncomeChartData"
						:volatilityChartData="volatilityChartData"
						:returnsChart="returnsChart"
						:returnsChartData="returnsChartData"
						:returnsChartNav="returnsChartNav"
						:returnsChartNavData="returnsChartNavData"
						:inceptionDate="inceptionDate"
						:maxDate="maxDate"
						:fundName="fundName"
						:indexName="indexName"
						:growthData="growthData"
						:selectedTab="getSelectedChartTab"
						:audience="audience"
						:widgetData="widgetData"
					>
						<template #growthIndexId>
							<slot name="growthIndexId" />
						</template>
						<template #annualReturnsIndexId>
							<slot name="annualReturnsIndexId" />
						</template>
						<template #volatilityIndexId>
							<slot name="volatilityIndexId" />
						</template>
						<template #standardDeviation>
							<slot name="standardDeviation" />
						</template>
						<template #superscript1>
							<slot name="superscript1" />
						</template>
						<template #superscript2>
							<slot name="superscript2" />
						</template>
						<template #superscript3>
							<slot name="superscript3" />
						</template>
						<template #superscript4>
							<slot name="superscript4" />
						</template>
						<template #superscript5>
							<slot name="superscript5" />
						</template>
						<template #superscript6>
							<slot name="superscript6" />
						</template>
						<template #superscript7>
							<slot name="superscript7" />
						</template>
					</charts-modal-content>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import ChartsModalContent from './charts-modal/ChartsModalContent';
export default {
	name: 'DetailChartsModal',
	components: {
		ChartsModalContent
	},
	props: [
		'volatilityChart',
		'volatilityEquityChart',
		'volatilityFixedIncomeChart',
		'returnsChart',
		'returnsChartData',
		'returnsChartNav',
		'returnsChartNavData',
		'inceptionDate',
		'maxDate',
		'fundName',
		'indexName',
		'selectedTab',
		'audience',
		'volatilityData',
		'growthData',
		'widgetData'
	],
	data() {
		return {
			scrollPosition: 0
		};
	},
	computed: {
		volatilityChartLarge() {
			return (
				(this.volatilityData && this.volatilityData.largeChart) || ''
			);
		},
		volatilityChartData() {
			const data =
				(this.volatilityData && this.volatilityData.largeOutput) || {};
			return Object.assign({}, data, {
				deviationAsOf:
					this.volatilityData &&
					this.volatilityData.deviationAsOfDate,
				returnsAsOf:
					this.volatilityData && this.volatilityData.returnAsOfDate,
				inceptionDate:
					this.volatilityData && this.volatilityData.inceptionDate,
				assetClass:
					this.volatilityData && this.volatilityData.assetClass,
				//the globally registered links mixin has a computed property for shareClass so thats where this value comes from
				shareClass: this.shareClass
			});
		},
		volatilityEquityChartData() {
			const data =
				(this.volatilityData &&
					this.volatilityData.equityLargeOutput) ||
				{};
			return Object.assign({}, data, {
				deviationAsOf:
					this.volatilityData &&
					this.volatilityData.deviationAsOfDate,
				returnsAsOf:
					this.volatilityData && this.volatilityData.returnAsOfDate,
				inceptionDate:
					this.volatilityData && this.volatilityData.inceptionDate
			});
		},
		volatilityEquityChartLarge() {
			return (
				(this.volatilityData && this.volatilityData.equityLargeChart) ||
				''
			);
		},
		volatilityFixedIncomeChartData() {
			const data =
				(this.volatilityData &&
					this.volatilityData.fixedIncomeLargeOutput) ||
				{};
			return Object.assign({}, data, {
				deviationAsOf:
					this.volatilityData &&
					this.volatilityData.deviationAsOfDate,
				returnsAsOf:
					this.volatilityData && this.volatilityData.returnAsOfDate,
				inceptionDate:
					this.volatilityData && this.volatilityData.inceptionDate
			});
		},
		volatilityFixedIncomeChartLarge() {
			return (
				(this.volatilityData &&
					this.volatilityData.fixedIncomeLargeChart) ||
				''
			);
		},
		getSelectedChartTab() {
			return this.selectedTab || '';
		}
	},
	mounted() {
		this.scrollPosition = window.scrollY;
		document.body.setAttribute('style', 'overflow:hidden;');

		//Sets a max height equal to window height on the scrollable element
		//Makes modal scrollable even on small screens
		const windowHeight = window.innerHeight;
		const modalHeightTarget = this.$refs.modalScroll;
		if (windowHeight && modalHeightTarget) {
			modalHeightTarget.style.maxHeight = `${windowHeight}px`;
		}
	},
	beforeUnmount() {
		document.body.setAttribute('style', '');
		window.scrollTo(0, this.scrollPosition);
	}
};
</script>

<style lang="less" scoped>
#chart-modal {
	background-color: rgba(0, 0, 0, 0.5);
	transition: opacity 0.3s ease;
	display: block;
	padding-left: 0;
	.modal-dialog {
		width: 80%;
		max-width: 1200px;
		height: calc(~'100vh - 60px');
		margin: 30px auto;
		.modal-container {
			transition: all 0.3s ease;
			height: 100%;
			margin: auto;
			width: 100%;
			overflow-x: hidden;
		}
	}
}
.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
@media (max-width: 768px) {
	#chart-modal .modal-dialog {
		margin: 0;
		height: 100vh;
		width: 100vw;
		max-width: 100vw;
		.modal-content {
			border: none;
			border-radius: initial;
		}
	}
}
</style>
